const appConfig = window.__APP_CONFIG__ ?? {};

function requireConfig(key) {
  const value = appConfig[key];
  if (!value) {
    throw new Error(`config.js 의 window.__APP_CONFIG__ 에 ${key} 가 없습니다`);
  }
  return value;
}

export const API_BASE_URL = requireConfig('API_BASE_URL');
export const LOGIN_URL = requireConfig('LOGIN_URL');
export const GRADING_ADMIN = appConfig.GRADING_ADMIN === true;
export const GRADING_COMPARISON_ORDER = Array.isArray(appConfig.GRADING_COMPARISON_ORDER) ? appConfig.GRADING_COMPARISON_ORDER.map(Number) : [];

const config = {
  basename: '/',
  adminPath: '/admin',
  defaultPath: '',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12
};

export default config;
